import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { ISectionProps } from './glossary.js';

export const GlossarySectionList = ({ items, classes }: Pick<ISectionProps, 'items' | 'classes'>) => {
  return (
    <div className={`Section-list-col col-gutter u-flex-1 ${classes}`}>
      {items.map(({ heading, children }, index) => (
        <div className="Glossary-item Section-list-items u-flexCol" key={index}>
          {heading && (
            <LinkFactoryReactRouter href={heading.url} className="Section-list-items-header u-linkClean">
              {heading.label}
            </LinkFactoryReactRouter>
          )}
          {children?.length && (
            <ul className="Glossary Section-list-items-content u-mT-0 u-mB-0 Glossary--child">
              {children.map(({ url, label }, childIdx: number) => (
                <li className="Glossary-item Section-list-item" key={childIdx}>
                  <LinkFactoryReactRouter href={url} className="u-linkClean">
                    {label}
                  </LinkFactoryReactRouter>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};
